import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

export interface AvtonetInfoStep {
  label: string;
  text: string;
}

export interface AvtonetInfoDialogData {
  title: string;
  intro?: string;
  steps: AvtonetInfoStep[];
  warning?: string;
  /** Show a "Povratna informacija" button that closes with 'feedback'. */
  showFeedback?: boolean;
  /** Label for the primary action button. Defaults to "Razumem". When set,
   *  clicking it closes with 'confirm' (e.g. the publish modal proceeds to
   *  avto.net only on this action, not on X/backdrop). */
  confirmLabel?: string;
}

@Component({
  selector: 'app-avtonet-info-dialog',
  templateUrl: './avtonet-info-dialog.component.html',
  standalone: false
})
export class AvtonetInfoDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AvtonetInfoDialogData,
    public dialogRef: MatDialogRef<AvtonetInfoDialogComponent>,
  ) {}

  static open(dialog: MatDialog, data: AvtonetInfoDialogData) {
    return dialog.open(AvtonetInfoDialogComponent, {width: '560px', data});
  }

  close() {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close('confirm');
  }

  feedback() {
    this.dialogRef.close('feedback');
  }
}
